import React from 'react';

export const formatPhone = inputValue => {
  let val = inputValue.replace(/\D/g, '');
  val = val.substr(0, 10);
  let newVal = '';

  if (val.length > 3 && val.length < 7) {
    newVal += `(${val.substr(0, 3)})`;
    val = val.substr(3);
  }
  if (val.length > 6) {
    newVal += `(${val.substr(0, 3)})`;
    newVal += `${val.substr(3, 3)}-`;
    val = val.substr(6);
  }
  newVal += val;
  return newVal;
};

export const boldText = initText =>
  initText
    .split(' ')
    .map(item =>
      item.includes('b/') ? (
        <b key={`bolded-${item}`}>{item.replace('b/', '')} </b>
      ) : (
        <span key={`normal-${item}`}>{item} </span>
      )
    );
